import React from "react"
import HomeBanner from "../Resource/images/HomeBanner.jpg"

const Homepage = () => {
  return (
    <div className="container mx-auto">
      <div className="text-center w-full pt-24 pb-12 px-6 md:px-0 xl:pb-24">
        <div className="w-fit mx-auto py-9">
        <img src={HomeBanner} alt="" className="rounded-xl my-6 md:my-6 w-full"/>
        </div>
        <div className="leading-10 space-y-9 text-lg md:text-2xl xl:text-3xl xl:space-y-12">
          <p>
            The Night Owls offers an enchanting and engaging experience for NFT collectors and Web3 explorers alike. Each Night Owl from the 5555 piece collection, possesses a distinct attribute, artistic story, and irresistible visuals making them highly valuable and sought after within the digital art realm.
          </p>
          <p>
            On top of their artwork, they individually come with their own utility and perks that you can benefit from by holding Night Owl NFTs and being a part of the community.
          </p>
          <p>


          </p>{" "}
          <p>


            </p>
        </div>
      </div>
    </div>
  );
};

export default Homepage
